import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import { 
  Button, 
  CircularProgress,
  Tooltip,
}                     from '@material-ui/core';

import { 
  GetApp as MoreIcon 
}                     from '@material-ui/icons';

// import Button from '@material-ui/core/Button';
// import TableCell from '@material-ui/core/TableCell';
// import TableRow from '@material-ui/core/TableRow';

import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

// import ExecutionInputLog from "./ExecutionInputLog";
import classnames from 'classnames';

// const fmtLogLink = (row) => {
//   return "https://us-west-2.console.aws.amazon.com/cloudwatch/home?region=us-west-2#logEventViewer:group=/pac/dl/168722687966/workload/test-workload-8/inputs;stream="+row.LogStream;
// };

const useStyles = makeStyles((theme) => ({
  RowAdded: {
    '& td': { backgroundColor: '#f8fff5'},
  },
  RowDeleted: {
    '& td': { textDecoration: 'line-through' },
  },
  RowUpdated: {
    '& td': {
      fontWeight: 'bold',
    }
  },
}));

export default function ExecutionInputDataTable(props) {
  
  const { data, columns, onSelect, title, loading, more, onLoadMore } = props;

  const [order, setOrder] = React.useState('desc');
  const [orderBy, setOrderBy] = React.useState('UpdateTime');
  // const [rowsExpanded, setRowsExpanded] = React.useState([]);

  const handleColumnSortChange = (changedColumn, direction) => {
    setOrder(direction);
    setOrderBy(changedColumn);
  };

  const handleCellClick = (colData, cellMeta) => {
    if(!columns[cellMeta.colIndex].clickable && onSelect) {
      onSelect(data[cellMeta.dataIndex]);
    }
  };


  // const handleRowClick = (rowData, rowMeta) => {
  //   if(onSelect) {
  //     onSelect(data[rowMeta.dataIndex]);
  //   }
  // };

  
  const classes = useStyles();

  // const handleRowExpansionChange = (curExpanded, allExpanded, rowsExpanded) => {
  //   if (allExpanded.length === 0) {
  //     setRowsExpanded([]);
  //   } else if (curExpanded.length > 0) {
  //     setRowsExpanded([curExpanded[0].dataIndex]);
  //   }
  // };
  
  const muiTheme = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          size: "small"
        },
        paper: {
          boxShadow: "none",
        },
      },
    }
  });

  const options = {
    enableNestedDataAccess: ".",
    // expandableRows: true,
    // expandableRowsHeader: false,
    print: false,
    //download: false,
    //filter: false,
    //viewColumns: false,
    //pagination: false,
    // renderExpandableRow: (rowData, rowMeta) => {
    //   const colSpan = rowData.length + 1;
    //   return (
    //     <TableRow>
    //       <TableCell colSpan={colSpan}>
    //         <Button target="_blank" href={fmtLogLink(data[rowMeta.dataIndex])}>Show logs in CloudWatch</Button>
    //         <ExecutionInputLog executionId={data[rowMeta.dataIndex].ExecutionId} inputUri={data[rowMeta.dataIndex].InputUri} />
    //       </TableCell>
    //     </TableRow>
    //   );
    // }, 
    // rowsExpanded: rowsExpanded,
    onColumnSortChange: handleColumnSortChange,
    onCellClick: handleCellClick,
    // onRowExpansionChange: handleRowExpansionChange,
    search: false,
    selectableRows: "none",
    sortOrder: {
      name: orderBy,
      direction: order
    },
    setRowProps: (row, dataIndex, rowIndex) => {
      return {
        className: classnames(
          {
            [classes.RowAdded]: data[dataIndex]._status === "ADDED",
            [classes.RowUpdated]: data[dataIndex]._status === "UPDATED",
            [classes.RowDeleted]: data[dataIndex]._status === "DELETED"
          }),
        style: { border: '0px solid blue', }
      };
    },
    setTableProps: () => {
      return {
        padding: "default",
        size: "small",
      };
    },
  };

  var displayTitle=null;
  
  if(loading) {
    displayTitle=<Button disabled size="small" style={{ width: '125px' }} startIcon={<CircularProgress size={20}/>}>Loading...</Button>;
  } else if(more) {
    displayTitle=
    <Tooltip title="Load more rows from server...">
     <Button size="small" style={{ width: '125px' }} startIcon={<MoreIcon/>} onClick={onLoadMore}>Load More</Button>
    </Tooltip>;
  }

  if(React.isValidElement(title)) {
    displayTitle=<React.Fragment>{title}{displayTitle}</React.Fragment>;
  }
  
  return (
    <MuiThemeProvider theme={muiTheme}>
      <MUIDataTable
        title={displayTitle || title || ""}
        data={data}
        columns={columns}
        options={options}
      />
    </MuiThemeProvider>
  );
  
}

ExecutionInputDataTable.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  loading: PropTypes.bool,
  more: PropTypes.bool,
  onLoadMore: PropTypes.func,
};

ExecutionInputDataTable.defaultProps = {
  data: [],
  title: "Execution Inputs",
};
